import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController,  ViewController, Slides, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';

import { UserMyRadiant as User } from '@providers/index';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant} from '@providers/index';
import { CalendarResult } from 'ion2-calendar';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '@providers/resources/utility';
import { TabsPage } from '@pages/dashboard';
import { DrawerState } from 'ion-bottom-drawer';
import { DetailEmployeeActivity, DetailIdle, DetailTrackingActivity } from "@pages/activity";
import { cmpDepartmentList } from '@src/components/departmentList/cmp';
import { Storage } from '@ionic/storage';
import { Tracker } from '@providers/activity';
import leaflet from 'leaflet';
import * as mapboxgl from 'mapbox-gl';
import { Geolocation } from '@ionic-native/geolocation';
declare var d3;
@Component({
  selector: 'history-tracking-asset',
  templateUrl: 'page.html'
})
export class HistoryTracking {

  berita:any = '';
  loading : any;
  riwayat = [];
  asset = {};
  data = {
    employee:[],
    employee_filter : [],
    selected:{
      department:[]
    },
    user:{
      lat : 0,
      lng : 0,
    },
    style : 'mapbox://styles/mapbox/outdoors-v9',
  };
  state = {
    skeleton : true,
    employee_selected : this.userApi.data.user_name,
  };

  today = this.helper.getToday();
  parameter : any = {
    asset_id : "",
  }
  map = mapboxgl.Map;
  marker: any = [];
  drawerOptions: any;
  fileTransfer: FileTransferObject = this.transfer.create();
  // @ViewChild('widgetSearch') private searchBar: Searchbar;
  // @ViewChild('map') mapContainer: ElementRef;
  // map: any;

  constructor(
    private api           : ApiMyRadiant,
    public userApi        : User,
    public alertCtrl      : AlertController,
    public nav            : Nav,
    public utility        : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    private photoViewer   : PhotoViewer,
    private file          : File,
    private transfer      : FileTransfer,
    private events        : Events,
    private modalCtrl     : ModalController,
    private storage       : Storage,
    public trackerProvider   : Tracker,
    private geolocation       : Geolocation,
    private navParams     : NavParams,
  ) {
      this.drawerOptions = {
        handleHeight: 0,
        thresholdFromBottom: 200,
        thresholdFromTop: 200,
        bounceBack: false,
        has_event_panup: true,
        event_panup : () => {
          document.getElementById('area-asset').style.height = "calc(100vh - 150px)";
        },
        has_event_pandown:true,
        event_pandown : () => {
          document.getElementById('area-asset').style.height = "calc(40vh - 70px)";
        },
      };
      let params = this.navParams.get('data');
      this.asset = params
      this.parameter.asset_id = params.id;
      mapboxgl.accessToken = this.userApi.tokenMapbox;
    }

    ionViewDidEnter() {
      let me = this;
      let watch = this.geolocation.watchPosition();
      this.geolocation.getCurrentPosition().then((data) => {
        this.data.user.lat = data.coords.latitude;
        this.data.user.lng = data.coords.longitude;
        this.loadmap();
        this.getHistory();
      });
    }

    getHistory(){
      let me = this;
      this.state.skeleton = true;
      this.trackerProvider.getHistorytAsset(this.parameter).subscribe((resp?:any) => {
        if(resp.success){
          resp.data.forEach(row => {
            this.riwayat.push(row);
          });
          // this.data.asset = resp.data;
          // console.log(this.state,this.data.employee);
          try {
            // this.loading.dismiss();
            setTimeout(() => {
              this.state.skeleton = false;
            }, 500);
          } catch (error) {}
        }
      },(err) => {
        this.helper.presentToast('Error');
        try {
          setTimeout(() => {
            this.state.skeleton = false;
          }, 500);
        } catch (error) {
          
        }
      }); 
    }

    drawRouteHistory(data){
      let me = this;
      let mapLayer = this.map.getLayer('route');
      this.marker.forEach(row => {
        row.remove();
      });
      if(typeof mapLayer !== 'undefined') {
        this.map.removeLayer('route').removeSource('route');
      }
      let coordinates = [];
      let history = JSON.parse(data.history);
      let routes = history.points;
           
      // start by showing just the first coordinate
      routes.forEach(position => {
        console.log(position);
        coordinates.push([position.longitude,position.latitude]);
      });

      console.log("awal coordinat",coordinates[0], "data coordinat => ",coordinates);
      let data_source = {
        'type': 'Feature',
        'properties': {},
        'geometry': {
          'type': 'LineString',
          'coordinates': coordinates[0]
        }
      };

      let mark_start = document.createElement('div');
      mark_start.className = 'marker-red';
      let a = new mapboxgl.Marker(mark_start).setLngLat(coordinates[0]).addTo(this.map);
      this.marker.push(a);
        
      // add it to the map
      me.map.addSource('route', { type: 'geojson', data: data_source });
      this.map.addLayer({
        'id': 'route',
        'type': 'line',
        'source': 'route',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        'paint': {
          'line-color': '#f49c1f',
          'line-width': 8,
          'line-opacity': 0.75,
        }
      });
        
      // setup the viewport
      me.map.jumpTo({ 'center': coordinates[0], 'zoom': 16 });
      me.map.setPitch(30);
        
      // on a regular basis, add more coordinates from the saved list and update the map
      var i = 1;
      var timer = window.setInterval(function() {
        if (i < coordinates.length) {
          data_source.geometry.coordinates.push(
            coordinates[i]
          );
          me.map.getSource('route').setData(data_source);
          me.map.panTo(coordinates[i]);
          i++;
        } else {
          //bikin marker doang
          let mark_end = document.createElement('div');
          mark_end.className = 'marker-orange';
          let b = new mapboxgl.Marker(mark_end).setLngLat(coordinates[coordinates.length - 1]).addTo(me.map);
          me.marker.push(b);
          //selesai bikin marker
          window.clearInterval(timer);
        }
      }, 50);


      
      // this.map.addSource('route', {
      //   'type': 'geojson',
      //   'data': {
      //     'type': 'Feature',
      //     'properties': {},
      //     'geometry': {
      //       'type': 'LineString',
      //       'coordinates': coordinates
      //     }
      //   }
      // });
      // this.map.addLayer({
      //   'id': 'route',
      //   'type': 'line',
      //   'source': 'route',
      //   'layout': {
      //     'line-join': 'round',
      //     'line-cap': 'round'
      //   },
      //   'paint': {
      //     'line-color': '#f49c1f',
      //     'line-width': 8
      //   }
      // });

      

      //camera view position kemana
      // this.map.flyTo({
      //   center:coordinates[Math.ceil(coordinates.length/2) -1],
      //   zoom: 16,
      //   speed: 0.9,
      //   curve: 1,
      //   easing(t) {
      //     return t;
      //   },
      //   essential: true
      // });
    }
   
    loadmap() {
      this.map = new mapboxgl.Map({
        container: 'map-history',
        style: this.data.style,
        attributionControl:false,
        zoom: 15,
        center: [this.data.user.lng,this.data.user.lat],
      });
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.addControl(new mapboxgl.GeolocateControl({
        positionOptions: {
        enableHighAccuracy: true,
        zoom:0
        },
        trackUserLocation: true
      }));
      this.map.on('load',() => {
        
      });    
    }
  
  backButton(){
    this.nav.setRoot(DetailTrackingActivity,{data:this.asset});
  }


  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }


  showListDepartment(){
    let me = this;
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/activity/tracking/history/page.ts